export const fullText = 'SOKOLOCO';
export const SiteUrl = 'https://sokoloco.gg';
